import Grid from '@mui/material/Grid';
import DataField from '../../atoms/dataField';
import React, { FC, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { CONNECTION_TYPES } from '../../../constants/_pickerValues';
import { IFormField } from '../../shared/globalTypes';
import { Alert } from '@mui/material';


interface Props {
  selectedConnection: string,
  s3Bucket: IFormField,
  s3Path: IFormField,
  onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined,
  kmsId? : IFormField
}

const ConnectionS3Bucket: FC<Props> = ({ selectedConnection, s3Bucket, s3Path, onChange, kmsId}: Props) => {
  const [visible, setVisible] = useState(false);


  useEffect(() => {
    if (selectedConnection === CONNECTION_TYPES.s3Buckets) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [selectedConnection]);

  if (visible) {
    return (
      <Box sx={{ border: 1, borderColor: 'divider', padding: 3, width: '100%' }}>
        <h2>{selectedConnection}</h2>
        <Grid container spacing={4}>
          <Grid item xs={4}>
            <DataField id="e96fe82b-df73-46fb-bb1a-f532fa1fc05a"
              label='Bucket Name'
              name='s3Bucket'
              type='text'
              required={true}
              onChange={onChange}
              value={s3Bucket.fieldValue}
              error={s3Bucket.isError}
            />
          </Grid>
          <Grid item xs={8}>
            <DataField id="7c11f574-2a85-4f20-865f-822c9c83b438"
              label='Path'
              name='s3Path'
              type='text'
              required={true}
              onChange={onChange}
              value={s3Path.fieldValue}
              error={s3Path.isError}
            />
          </Grid>
          {kmsId && <Grid item xs={4}>
            <DataField id="9e945b6c-03fb-40c8-ae04-5f9f178c1235"
              label='KMS ID'
              name='kmsId'
              type='text'
              required={true}
              onChange={onChange}
              value={kmsId.fieldValue}
              error={kmsId.isError}
            />
          </Grid>}
          <Grid item xs={8}>
            <Alert severity="info">Please contact askunity@riotinto.com to ensure firewall rules are in place to enable connectivity for this S3 target's with the Unity system.</Alert>
          </Grid>
        </Grid>
      </Box>
    )
  } else {
    return <></>;
  }

};

export default ConnectionS3Bucket;